export enum GroupName {
  COMPANY_DETAILS = 'Business details',
  PERSONAL_DETAILS = 'Personal details',
  UPLOAD_DOCUMENTS = 'Upload documents',
  DONE = 'Done',
}
